var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ChatBox,{attrs:{"chatid":'witz01',"greeting1":'Willkommen im PV Chat',"greeting2":'Schreiben Sie Ihre Frage oder treffen Sie eine Auswahl!',"prompts":[
'Ich habe mein Kennwort vergessen?',
'Wie oft muss ich meinen Antrag für die KfW-Förderung 442 erneuern? '


]}})
}
var staticRenderFns = []

export { render, staticRenderFns }